import React, { useState, useEffect } from 'react';
import { ENDPOINTS } from 'constants/endpoints';
import { ProfileProgressStepsList } from 'constants/progress-steps-constants';
import { SuccessButton } from 'components/button';
import { useHistory } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import { useDispatch, useSelector } from 'react-redux';
import { CommonStyledComponentProps } from '__utils/type';
import { getEncryptedUserId, getQueryParamsFromString, isBtoCFlow, isFlowTypeCheckout, isFlowTypeProfile } from '__utils/common-utils';
import { get, getDefaultHeaders } from '__utils/ajax-wrapper';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import CartSummary from 'components/cart-summary/index';
import OnboardingProgressSteps from 'components/onboarding-progress-steps';
import styled from 'styled-components';
import useFlashToggler from 'hooks/use-flash-toggler';
import CartSelector from 'views/cart/cart.selector';
import lowRisk from 'images/LowRisk.svg';
import highRisk from 'images/highRisk.svg';
import moderatelyHighRisk from 'images/ModeratelyHighRisk.svg';
import moderatelyLowRisk from 'images/moderatelyLowRisk.svg';
import moderateRisk from 'images/moderateRisk.svg';
import veryHighRisk from 'images/VeryHighRisk.svg';
import { propsToJS } from '__utils/immutable-to-js';
import * as Actions from 'constants/actions';
import { getAgentCode, getUserDetails } from '__utils/storage';
import { redirectToOld } from '__utils/common-utils';
import * as riskProfileviewActions from '../risk-profile.actions'
import RiskProfileViewSelector from '../risk-profile.selector';
import ProfileViewSelector from 'views/investor-profile/profile-view.selector';
import { getEventName, Mixpanel } from '__utils/mixpanel';
// import { showPaymentModePopupAction } from 'components/payment-mode/payment-mode.action';
import { fetchCartDetails } from 'views/cart/cart.actions';
import Footer from 'components/footer';
import MobileFooterLayout from 'components/old-footer-layout';
import { LayoutContext } from 'components/app-routes';
import { CommonTitleDiv } from 'views/common-styled-components';
import { AGENT_STATUS } from 'constants/common-constants';


const RiskProfileResultsWhiteCard = styled.div<CommonStyledComponentProps>`
    padding: ${(props: any) => !props.isMobile ? "0 0 16px 24px" : "16px"};
    margin-bottom: 30px;
    height: auto;
    overflow: auto;
    .inner-cont {
        padding: 15px 0px;
        width:  ${(props: any) => !props.isMobile ? "100vw" : "auto"};
    }
    .display-flex{
        margin: 24px 24px 0 0;
        display: flex;
        padding: 15px 0px;
    }
    .h1Text {
        font-size: ${(props: any) => props.isMobile ? "36px" : "24px"};
        font-weight: 700;
        color: #00A465; 
        margin-top: 20px;       
    }
    #subTitle{
        font-size: 16px;
        // width: ${(props: any) => !props.isMobile ? "max-content" : ""};
    }
    .description{
        text-align: justify;
        font-size: 16px;
        line-height: 1.3;   
    }
    .align-center{
        // width: 320px;
        text-align: center;
    }
  
    .ml-30{
        margin-left: ${(props: any) => !props.isMobile ? "30px" : ""};
    }
    .ml-150{
        margin-left: ${(props: any) => !props.isMobile ? "150px" : ""};
    }
   b{
       font-weight: 500;
   }
`;
const ContinueBtn = styled(SuccessButton)`
        width: 260px;
        margin-top: 1rem;
        font-size: 14px; 
`;

const RiskProfileResults: React.FC = () => {
    const history = useHistory();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { userType } = getQueryParamsFromString(window.location.search);
    const dispatch = useDispatch();
    const [ riskFactor, setRiskFactor ] = useState<any>();
    const { cartDetails } = propsToJS(useSelector(CartSelector));
    const { profileViewError } = propsToJS(useSelector(ProfileViewSelector));
    const { riskProfileResult } = propsToJS(useSelector(RiskProfileViewSelector));
    const [ maxuserAttemptId, setMaxUserAttemptId ] = useState<any>();
    // const { showPaymentModePopup } = propsToJS(useSelector(PaymentModeSelector));
    const isCartFull = cartDetails && cartDetails?.noOfItems > 0;
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    const { layoutProps, SetLayoutProps } = React.useContext(LayoutContext);
    const flash = useFlashToggler();


    const riskParams: any = {
        1: {
            src: lowRisk,
            title: "Conservative",
            categories: ["Overnight Fund" ,"Liquid fund" ,"Arbitrage Fund"],
        },
        2: {
            src: moderatelyLowRisk,
            title: "Moderately Conservative",
            categories: ["Ultra Short Duration Fund","Low Duration Debt Fund","Short Duration Debt Fund","Money Market Fund"]
        },
        3: {
            src: moderateRisk,
            title: "Moderate",
            categories: ["Medium Duration Debt Fund","Equity Savings Fund","Long Duration Fund"]
        },
        4: {
            src: moderatelyHighRisk,
            title: "Moderately High",
            categories: ["Equity Savings Fund","Conservative Hybrid Fund"]
        },
        5: {
            src: highRisk,
            title: "High",
            categories: ["Equity Savings Fund", "Balanced Advantage Fund"]
        },
        6: {
            src: veryHighRisk,
            title: "Very High",
            categories: ["Multicap Fund" ,"Flexicap Fund" ,"Midcap Fund" ,"Smallcap Fund","Large cap Fund", "Large & Midcap Fund", "Multi Asset Fund", " Aggressive Hybrid Fund"],
        }
    }

    useEffect(() => {
        isFlowTypeCheckout() && SetLayoutProps({
            config: { title: 'Investor Profile' }
        })
        dispatch(fetchCartDetails());
        dispatch(riskProfileviewActions.fetchRiskProfileResult());
        fetchQuestions();
        Mixpanel.track(getEventName("riskProfileResult", "loaded", "checkout"), {
            agentCode: getAgentCode(),
            user: getUserDetails(),
            isBtoCFlow: isBtoCFlow(),
        });
    }, [])

    useEffect(() => {
        setRiskFactor(riskProfileResult?.riskProfileClassId);
    }, [ riskProfileResult ])

    const fetchMaxAttemptId = (riskProfileVersion: any) => {
        get(`${ENDPOINTS.GET_RISK_PROFILE_MAX_USER_ATTEMPT_ID}/${getEncryptedUserId()}?risk-profile-version=${riskProfileVersion}`, getDefaultHeaders(), false)
            .subscribe((response: AjaxResponse | AjaxError) => {
                setMaxUserAttemptId(response?.response?.data ? (response?.response?.data + 1) : 2);
            }, (error: AjaxError) => {
                flash.error('Something went wrong.Please try again later');
            });
    }
    const fetchQuestions = () => {
        get(`${ENDPOINTS.GET_RISK_PROFILE_QUESTIONS}`, getDefaultHeaders(), false)
            .subscribe((response: AjaxResponse | AjaxError) => {
                fetchMaxAttemptId(response?.response?.data[ 0 ]?.riskProfileVersion);
            }, (error: AjaxError) => {
                flash.error('Something went wrong.Please try again later');
            });
    }
    const isCartApproved = () => {
        if (cartDetails?.agentStatus === AGENT_STATUS.APPROVED)
            return true;
    }
    const retakeTest = (flowType: string) => {
        Mixpanel.track(getEventName("retakeRiskProfileTest", "clicked", "checkout"), {
            agentCode: getAgentCode(),
            user: getUserDetails(),
            isBtoCFlow: isBtoCFlow(),
        });
        history.push(`risk-profile?flowType=${flowType}&completed=true&userAttemptId=${maxuserAttemptId}`);
    }

    const getCTA = () => {
        if (isFlowTypeCheckout())
        {
            return 'Continue'
        }
        else
        {
            return 'Retake The Test'
        }
    }

    const submitNProccedtoNext = () => {
        if (isFlowTypeCheckout())
        {
            if (profileViewError) flash.error(profileViewError, 30000);
            dispatch({
                type: Actions.SET_ENC_REQUIREMENT_ID,
                payload: 1
            })
            if(userType === 'old'){
                redirectToOld('cart-review');
            }
            else history.push('/profile/occupation-nominee-details?flowType=checkout');
        }
        else
        {
            retakeTest('profile');
        }
    }
    const getWidthOfDescription = () => {
        const elementWidth: HTMLElement | null = document.getElementById('subTitle');
        return `${elementWidth?.offsetWidth}`
    }
    const returnComponent = () => {
        return (
            <div>
                <div style={ isMobile ? { display: "flex", flexDirection: "column" } : {} }>
                    <div className={ (!isMobile && isFlowTypeCheckout()) ? 'cardCont' : '' }>
                        <RiskProfileResultsWhiteCard isMobile={ isMobile }>
                            { (!isMobile && isFlowTypeCheckout()) && <CartSummary /> }
                            { !isMobile && (isFlowTypeCheckout() && <CommonTitleDiv>Investor Profile</CommonTitleDiv>) }
                            { (isFlowTypeCheckout()) && <OnboardingProgressSteps
                                stepsList={ ProfileProgressStepsList }
                                currentStep={ 2 }
                            /> }
                            <div className={ isMobile ? "risk-white-card" : "" } style={ { marginBottom: isMobile ? (isFlowTypeProfile() ? "120px" : "60px") : "30px" } }>
                                <div className={ isMobile ? "" : isFlowTypeCheckout() ? (isCartFull ? "inner-cont" : "display-flex") : "display-flex" }>
                                    <div className={ !isMobile ? "" : "align-left" } style={ { marginBottom: isMobile ? "" : isFlowTypeCheckout() ? (isCartFull ? "10px" : "80px") : "10px", width: "100%" } }>
                                        <object data={ riskParams[ riskFactor ]?.src } style={ { marginTop: "10px",width: `${isMobile ? "100%" : "450px"}` } }></object>
                                    </div>
                                    <br/>
                                    <div className={ isFlowTypeCheckout() ? isCartFull ? "" : "ml-150" : "ml-30" }>
                                        <div style={ { textAlign: "justify" } }>
                                            <div>
                                                <div id="subTitle">Based on your answers, your risk assessment is <b>{ riskProfileResult?.riskProfileName }</b>. Here are some categories that you may consider based on your risk profile:</div><br/>
                                                <div style={{marginLeft: "32px"}}>
                                                    <ul className="description">{ riskParams[ riskFactor ]?.categories?.map((item: string)=> <li>{item}</li>) } </ul> <br />
                                                </div>
                                                <div className="description">These funds align with your risk tolerance.</div> <br />
                                            </div>
                                        </div><br />
                                        { isFlowTypeCheckout() &&
                                            <><a onClick={ () => retakeTest('checkout') }
                                                className="retakeTestLink">Retake the test</a><br /><br /></> }
                                        { !isMobile &&
                                            <>
                                                <ContinueBtn onClick={ () => submitNProccedtoNext() }>{ getCTA() }</ContinueBtn>
                                                { (isFlowTypeCheckout() && (cartDetails?.noOfItems > 0 && !isCartApproved())) &&
                                                    <p className="greyText mt-10 font14">*Your cart is awaiting for approval.</p> }
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                            { (!isFlowTypeCheckout() && !isMobile) &&
                                <p className="queryText">If you need any help or have any query just write to us at <a href="mailto:help@turtlemintmoney.com">help@turtlemintmoney.com</a> or call us at: <a href="tel:18002666468"> 18002666468</a>.</p> }
                        </RiskProfileResultsWhiteCard>
                    </div >


                </div>
                { isMobile && <div className="sticky-footer" style={ { bottom: isFlowTypeProfile() ? "60px" : "0" } }>
                    <div>
                        {  (isMobile && (isFlowTypeCheckout() && cartDetails?.noOfItems > 0 && !isCartApproved())) && 
                        <p className="sticky-greyText" >*Your cart is awaiting for approval.</p> }
                    </div>
                    <div style={ { bottom: isFlowTypeProfile() ? "60px" : "0" } }>
                        <SuccessButton onClick={ () => submitNProccedtoNext() }>{ getCTA() }</SuccessButton>
                    </div>
                    { isFlowTypeProfile() && <Footer>
                        <MobileFooterLayout />
                    </Footer> }
                </div> }
                {/* { showPaymentModePopup && <PaymentMode /> } */ }
            </div>
        );
    }
    return (
        <div>
            { returnComponent() }
        </div>);
};

export default RiskProfileResults;
